"use client";

import * as React from "react";
import styled, { css, keyframes } from "styled-components";

export type Shaker = {
  shake: () => void;
};

type ShakeableProps = {
  children?: React.ReactNode | undefined;
  shaker: React.MutableRefObject<Shaker | null>;
  className?: string;
};

export const Shakeable: React.FC<ShakeableProps> = (props) => {
  const containerRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    props.shaker.current = {
      shake: () => {
        if (!containerRef.current) {
          return;
        }

        containerRef.current.classList.add("shake");
        setTimeout(() => {
          containerRef.current?.classList.remove("shake");
        }, 2000);
      },
    };
  }, [props.shaker]);

  return (
    <ShakeableContainer ref={containerRef} className={props.className}>
      {props.children}
    </ShakeableContainer>
  );
};

const shake = (base = "0px") => keyframes`
  10%, 90% {transform: translateX(calc(${base} + -1px));}

  20%, 80% {transform: translateX(calc(${base} + 2px));}

  30%,
  50%,
  70% {transform: translateX(calc(${base} + -4px));}

  40%,
  60% {transform: translateX(calc(${base} + 4px));}
`;

export const ShakeAnimation = (base = "0px") => css`
  transform: translateX(${base});
  animation: ${shake(base)} 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
`;

const ShakeableContainer = styled.div`
  width: 100%;

  &.shake {
    ${ShakeAnimation()}
    backface-visibility: hidden;
    perspective: 1000px;
  }
`;
